import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _hover, _active, _defineStyle, _defineStyle2, _defineStyle3;
// src/components/close-button.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";
var $size = cssVar("close-button-size");
var $bg = cssVar("close-button-bg");
var baseStyle = defineStyle({
  w: [$size.reference],
  h: [$size.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: (_hover = {}, _defineProperty(_hover, $bg.variable, "colors.blackAlpha.100"), _defineProperty(_hover, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.100")), _hover),
  _active: (_active = {}, _defineProperty(_active, $bg.variable, "colors.blackAlpha.200"), _defineProperty(_active, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.200")), _active),
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: $bg.reference
});
var sizes = {
  lg: defineStyle((_defineStyle = {}, _defineProperty(_defineStyle, $size.variable, "sizes.10"), _defineProperty(_defineStyle, "fontSize", "md"), _defineStyle)),
  md: defineStyle((_defineStyle2 = {}, _defineProperty(_defineStyle2, $size.variable, "sizes.8"), _defineProperty(_defineStyle2, "fontSize", "xs"), _defineStyle2)),
  sm: defineStyle((_defineStyle3 = {}, _defineProperty(_defineStyle3, $size.variable, "sizes.6"), _defineProperty(_defineStyle3, "fontSize", "2xs"), _defineStyle3))
};
var closeButtonTheme = defineStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md"
  }
});
export { closeButtonTheme };